module.exports = __webpack_public_path__ + "static/img/xygame.5b37ce30.png";